/* tslint:disable:whitespace max-line-length */
export { IProps } from "./Disclaimers-ThirdParty";
let Disclaimers;
if (process.env.CLIENT === "CapOne") {
    ({ default: Disclaimers } = require("./Disclaimers-CapOne"));
}
else {
    ({ default: Disclaimers } = require("./Disclaimers-ThirdParty"));
}
export default Disclaimers;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/Disclaimers.tsx